import { Box } from "@outschool/backpack";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import ldWithout from "lodash/without";
import React from "react";

import { Filter } from "./Filter";

type BooleanFilterOption = {
  label: string;
  value: string;
};

type BooleanFiltersProps = {
  label: string;
  filters: Array<string | BooleanFilterOption>;
  enabledFilters: Array<string>;
  setEnabledFilters: React.Dispatch<React.SetStateAction<string[]>>;
  handleChangesExternally?: boolean;
  onChange?: (value: string[]) => void;
  hideFormat?: boolean;
};

export default function BooleanFilters({
  label,
  filters,
  enabledFilters,
  setEnabledFilters,
  onChange,
  hideFormat,
}: BooleanFiltersProps) {
  return (
    <Filter title={label}>
      <Box
        flex
        sx={{
          flexDirection: "column",
          gap: "0.25em",
          marginBottom: hideFormat ? "0.25em" : "1em",
        }}
      >
        {filters
          .map((v: string | BooleanFilterOption): BooleanFilterOption => {
            if (typeof v === "string") {
              return {
                label: v,
                value: v,
              };
            }
            return v;
          })
          .map(({ label, value: v }) => (
            <Checkbox
              key={v}
              label={label}
              name={label}
              checked={!!enabledFilters.find(t => t === v)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const checked = e.target.checked;
                const newFilters = checked
                  ? [...enabledFilters, v]
                  : ldWithout(enabledFilters, v);
                setEnabledFilters(newFilters);

                if (onChange) {
                  onChange(newFilters);
                }
              }}
            />
          ))}
      </Box>
    </Filter>
  );
}
